import { PageId } from 'constants/pages'
import type { TPageConfig } from 'models/common.model'
import { PageIdIntlD70 } from './pages'
import { HeaderId } from 'root-constants'

export const ID_TO_PAGE_CONFIG_MAP_INTL_D70: Record<
  PageIdIntlD70,
  TPageConfig
> = {
  [PageId.OFFER_INTL_D70]: {
    id: PageId.OFFER_INTL_D70,
  },
  [PageId.PAYMENT_INTL_D70]: {
    id: PageId.PAYMENT_INTL_D70,
  },
  [PageId.CHECKOUT_INTL_D70]: {
    id: PageId.CHECKOUT_INTL_D70,
  },
  [PageId.UPSELL_INTL_D70]: {
    id: PageId.UPSELL_INTL_D70,
  },
  [PageId.REGISTRATION_INTL_D70]: {
    id: PageId.REGISTRATION_INTL_D70,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.NAME_ENTRY_INTL_D70]: {
    id: PageId.NAME_ENTRY_INTL_D70,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.CERTIFICATE_INTL_D70]: {
    id: PageId.CERTIFICATE_INTL_D70,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.LEARNWORLDS_REDIRECT_INTL_D70]: {
    id: PageId.LEARNWORLDS_REDIRECT_INTL_D70,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.REPORT_INTL_D70]: {
    id: PageId.REPORT_INTL_D70,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
}
